import {uniqueUuid} from "@vesta/unique/unique";

export const SYSTEM_USER_ID = uniqueUuid`53098c5b-0c57-44fa-8c90-91d745f2cd1b`;
